var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.512 14.3481V4.75654L14.7171 8.55142V4.28218H8.44607L18.512 14.3481ZM1.82402 0.354492L0.486328 1.69218L3.07633 4.28218H1.43505V15.6668H14.4609L17.3071 18.513L18.6448 17.1753L1.82402 0.354492Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCamera);
export default __webpack_public_path__ + "static/media/no-camera.8865bf7ede230e70cdb6a4ea56a19860.svg";
export { ForwardRef as ReactComponent };